import { useParams } from "react-router-dom";
import AudioP1 from "../themes/phase1/AudioP1";
import AudioP2 from "../themes/phase2/AudioP2";
import AudioP3 from "../themes/phase3/AudioP3";
import AudioP4 from "../themes/phase4/AudioP4";
import AudioP5 from "../themes/phase5/AudioP5";

export default function DynamicAudioHandler() {
  const { phaseTitle } = useParams();

  if (phaseTitle === "Phase 1") return <AudioP1 />;
  if (phaseTitle === "Phase 2") return <AudioP2 />;
  if (phaseTitle === "Phase 3") return <AudioP3 />;
  if (phaseTitle === "Phase 4") return <AudioP4 />;
  if (phaseTitle === "Phase 5") return <AudioP5 />;
}
